// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/thumbs-down.js';

import { paths } from '../generated/thumbs-down';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('thumbs-down', Original, paths);
